module.exports = __webpack_public_path__ + "img/avatar.a0149dcd.png";